<p-panel
  [id]="id()"
  [header]="header()"
  [collapsed]="actualCollapsed()"
  (collapsedChange)="toggle()"
  [toggleable]="true"
  [toggler]="'header'">
  <ng-template #icons>
    <span class="panel-toggle-icon" [class.collapsed]="actualCollapsed()">
      <i [class]="actualCollapsed() ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></i>
    </span>
  </ng-template>
  <ng-content></ng-content>
</p-panel>